import React from "react";

export default function Header()
{
        const APP_NAME = process.env.REACT_APP_NAME;
        return (
            
            <div style = {{height:"100%", width:"100%"}}>
            <div style={{float :"left", width:"100%",height:"40px",paddingLeft:"10px" ,paddingTop:"10px",
            backgroundColor:"blue", color:"white",textAlign:"left",fontSize:"25px"}}>{APP_NAME} </div>
            </div>)
            
    }